import Vue from "vue";

Vue.prototype.config = {
  dir_asset: "../../"
};



// WEBPACK FOOTER //
// ./src/config/Variable.js